module.exports = __webpack_public_path__ + "components/resort-webcams/static/snoweye-logo-89f63978fcb1ec339deec0a7aa787477.gif";